import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="px-4 md:px-6 lg:px-8 py-12 md:py-14">
        <div className="max-w-[1440px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-500"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-50">
                  蘑菇影视
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                高清影视，畅享无限。致力于为全球华语用户提供最优质的在线观影体验，无广告、不缓冲。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    电视剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    动漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    综艺
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    联系我们
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs text-primary-500"></i>
                  </div>
                  support@mogumovie.com
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-xs text-primary-500"></i>
                  </div>
                  400-888-8888
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line text-xs text-primary-500"></i>
                  </div>
                  周一至周日 9:00-21:00
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-foreground-400 hover:text-primary-400 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-foreground-400 hover:text-primary-400 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500/30 transition-colors duration-200 cursor-pointer" rel="nofollow">
                  <i className="ri-tiktok-line text-foreground-400 hover:text-primary-400 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2020-2026 蘑菇影视 MoguMovie. All Rights Reserved.
            </p>
            <p className="text-xs text-foreground-500">
              ICP备案号：京ICP备2020XXXXXX号
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}